import { Action } from '@ngrx/store';
import { CommentDto } from '@app/generated/model';

export enum CommentsActionTypes {
  AddComment = 'AddComment',
  DeleteComment = 'DeleteComment',
  LoadMIPSComments = 'LoadMIPSComments',
  LoadMIPSCommentsSuccess = 'LoadMIPSCommentsSuccess',
  LoadCommentCount = 'LoadCommentCount',
  LoadCommentCountSuccess = 'LoadCommentCountSuccess',
}

export class AddCommentAction implements Action {
  readonly type = CommentsActionTypes.AddComment;
  constructor(
    public isMaterial: boolean,
    public isWorkLine: boolean,
  ) {}
}

export class DeleteCommentAction implements Action {
  readonly type = CommentsActionTypes.DeleteComment;
  constructor(
    public isMaterial: boolean,
    public isWorkLine: boolean,
  ) {}
}

export class LoadMIPSCommentsAction implements Action {
  readonly type = CommentsActionTypes.LoadMIPSComments;
  constructor(public workOrderId: string) {}
}

export class LoadMIPSCommentsSuccessAction implements Action {
  readonly type = CommentsActionTypes.LoadMIPSCommentsSuccess;

  constructor(public commentDtos: CommentDto[]) {}
}

export class LoadCommentCountAction implements Action {
  readonly type = CommentsActionTypes.LoadCommentCount;
  constructor(public workOrderId: string) {}
}

export class LoadCommentCountSuccessAction implements Action {
  readonly type = CommentsActionTypes.LoadCommentCountSuccess;
  constructor(
    public workOrderId: string,
    public comments: number,
    public materialComments: number,
    public workLineComments: number,
  ) {}
}

export type CommentsActions =
  | AddCommentAction
  | DeleteCommentAction
  | LoadMIPSCommentsAction
  | LoadMIPSCommentsSuccessAction
  | LoadCommentCountAction
  | LoadCommentCountSuccessAction;
